module.exports = (__parcel__import__("3njED")).then(() => parcelRequire('kRw5D'));